import React from "react";
import { useNavigate } from "react-router-dom";
import AppShell from "@/components/layout/AppShell";
import { Card } from "@/components/ui/card";
import { Ticket, Spade, Trophy, ArrowRight } from "lucide-react";

const RAFFLE_TYPES = [
  {
    id: "pick_a_sports_card",
    title: "Pick A Sports Card",
    description: "40 sports cards are laid out. Players claim a sport — the concealed winning sport takes the prize!",
    icon: Spade,
    route: "/a/raffles/pick-a-sports-card",
    color: "hsl(var(--primary))",
  },
];

export default function AdminRaffles() {
  const navigate = useNavigate();

  return (
    <AppShell variant="admin" title="Raffles">
      <div className="space-y-6" data-testid="raffles-page">
        {/* Header */}
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-[hsl(var(--primary)/0.1)]">
            <Ticket className="h-5 w-5 text-[hsl(var(--primary))]" />
          </div>
          <div>
            <h2 className="text-lg font-bold text-[hsl(var(--fg))]">Choose a Raffle Type</h2>
            <p className="text-sm text-muted-foreground">Select a raffle game to set up and manage</p>
          </div>
        </div>

        {/* Raffle type cards */}
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {RAFFLE_TYPES.map((raffle) => {
            const Icon = raffle.icon;
            return (
              <Card
                key={raffle.id}
                className="group relative overflow-hidden cursor-pointer border border-[hsl(var(--border))] hover:border-[hsl(var(--primary)/0.4)] hover:shadow-md transition-all duration-200"
                onClick={() => navigate(raffle.route)}
                data-testid={`raffle-type-${raffle.id}`}
              >
                <div className="p-2">
                  <img
                    src="/pick-win-sports-card.png"
                    alt="Pick & Win Sports Card"
                    className="w-full h-auto rounded-sm object-contain"
                    draggable={false}
                  />
                </div>
              </Card>
            );
          })}
        </div>
      </div>
    </AppShell>
  );
}
